import { omit } from 'ramda';
import { connect } from 'react-redux';
import { compose, withHandlers, mapProps, pure } from 'recompose';

import { getUsers } from '../../redux/selectors';
import { openModal, modalNames } from '../../modals/';
import { handleRequestDelete } from '../../redux/thunk/requests';
import RequestHeader from '../../components/requests-list-item/request-header';


const enhance = compose(
  connect(state => ({
    users: getUsers(state),
  }), {
    openModal,
    handleRequestDelete,
  }),

  withHandlers({
    onMeetingNoteCreate: actions => (requestId) => {
      actions.openModal({
        payload: { requestId },
        name: modalNames.ADD_MEETING_NOTES,
        width: 900,
        isCloseIconOuter: true,
      });
    },
    onCommentCreate: actions => (requestId) => {
      actions.openModal({
        name: modalNames.COMMENTS,
        payload: { requestId },
      });
    },
    onBudgetCreate: actions => (requestId) => {
      actions.openModal({
        name: modalNames.BUDGET,
        payload: { requestId },
        width: 315,
      });
    },
    onTaskCreate: actions => (requestId) => {
      actions.openModal({
        name: modalNames.TASKS,
        payload: { requestId },
      });
    },
    handleRequestUpdate: actions => (requestId) => {
      actions.openModal({
        name: modalNames.EDIT_REQUEST,
        payload: { requestId },
      });
    },
  }),
  mapProps(omit(['openModal'])),
  pure,
);

export default enhance(RequestHeader);



// WEBPACK FOOTER //
// ./src/containers/requests-list-item/request-header.js